import CardSection from "../CardSection"
import DetailsCard from "../DetailsCard"
import InputField from "../InputField"
import {createUseStyles} from "react-jss"

interface Props {
    filterValue: string
    onFilterChange: (value: string) => void
    includeTerminated: boolean
    onIncludeTerminatedChange: (value: boolean) => void
}

const CustomerFilter = ({
    filterValue,
    onFilterChange,
    includeTerminated,
    onIncludeTerminatedChange
}: Props) => {
    const styles = useStyles()
 
    return (
        <CardSection>
            <DetailsCard>
                <InputField
                    id="customerSearchField"
                    placeholder="Search customers..."
                    value={filterValue || ''}
                    onEnterKeyOrBlur={value => onFilterChange(value)}
                />
                <label className={styles.includeTerminated}>
                    <input
                        id='includeTerminated'
                        type='checkbox'
                        checked={includeTerminated}
                        onChange={(e) => onIncludeTerminatedChange(e.target.checked)}
                    />
                    <span>Include terminated</span>
                </label>
            </DetailsCard>
        </CardSection>
    )
}

export default CustomerFilter

const useStyles = createUseStyles({
    includeTerminated: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        columnGap: 8,
        marginTop: 8,
        paddingBottom: 8
    }
})
